import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

const setAllocationRequirement = async (
  surplus_from_offroad: any,
  sub_requirement_advanced_biofuels: any,
  general_requirement: any,
  reserved_quantity: any,
  joint_fulfillment_out: any,
  remaining_quantity: any
) => {
  const token = getToken();
  let valid = false;
  let result;
  const params = {
    surplus_from_offroad,
    sub_requirement_advanced_biofuels,
    general_requirement,
    reserved_quantity,
    joint_fulfillment_out,
    remaining_quantity,
  };

  if (token) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/sustainability_reports/set_requirement_allocation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(params),
        }
      );

      result = await response.json();
      valid = result && result.success;
    } catch (except) {
      valid = false;
    }
  }

  if (!valid) {
    if (result && result.errors) {
      return {
        valid: false,
        message: result.errors,
      };
    }
    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }

  return {
    valid: true,
  };
};

export default setAllocationRequirement;
